import { render, staticRenderFns } from "./OrderDetailPanel.vue?vue&type=template&id=3fd4c1de"
import script from "./OrderDetailPanel.vue?vue&type=script&lang=js"
export * from "./OrderDetailPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports